import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORM_URL } from 'app/@common/constants'

export default function SelectLocationCategory({...props}) {

    const myProps = {
        urlAjax: FORM_URL.LOCATION_CATEGORY,
        placeholder: i18n.t('common:filters.category'),
        icon: {icon: 'ballot'},
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
